<div class="app-container" dir="rtl">
    @if (isMobileEnv) {
        @if (currentPage.length > 0) {
        <div class="pageTitle"> {{ currentPage }} </div>
        }
        @if (!isMobBannerClose) {
        <div class="mobile-download-container">
            <app-download-app-banner (isClosedEmitter)="closeMobBanner($event)"></app-download-app-banner>
        </div>
        }
    }

    <div class="download-container">
        <app-download-app></app-download-app>
    </div>
    <div class="page-container custom-scroll">
        <router-outlet></router-outlet>
    </div>
</div>